"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _javascriptRulesEngine = _interopRequireDefault(require("@switchboard/javascript-rules-engine"));
var _javascriptCoreRules = _interopRequireDefault(require("@switchboard/javascript-core-rules"));
var _hivemindCommon = require("@godaddy/hivemind-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SwitchboardWrapper = exports["default"] = /*#__PURE__*/function () {
  function SwitchboardWrapper(_ref) {
    var settings = _ref.settings;
    _classCallCheck(this, SwitchboardWrapper);
    this._settings = settings;
    this._engine = new _javascriptRulesEngine["default"]({
      plugins: [_javascriptCoreRules["default"]],
      immutable: true
    });
  }
  _createClass(SwitchboardWrapper, [{
    key: "getCohortAllocations",
    value: function getCohortAllocations(_ref2) {
      var _this = this;
      var experiments = _ref2.experiments,
        attributes = _ref2.attributes;
      return Object.fromEntries(this._getExperimentSettings(experiments).map(function (setting) {
        return [setting.setting, _this._engine.resolveValue(setting, attributes)];
      }));
    }
  }, {
    key: "getExperimentsById",
    value: function getExperimentsById(experimentIds) {
      var settings = this._getExperimentSettings(experimentIds);
      return (0, _hivemindCommon.settingsToExperiments)(settings);
    }
  }, {
    key: "getExperiments",
    value: function getExperiments() {
      return (0, _hivemindCommon.settingsToExperiments)(this._settings);
    }
  }, {
    key: "_getExperimentSettings",
    value: function _getExperimentSettings(experimentIds) {
      var idSet = new Set(experimentIds);
      return this._settings.filter(function (_ref3) {
        var setting = _ref3.setting;
        return idSet.has(setting);
      });
    }
  }]);
  return SwitchboardWrapper;
}();